/* eslint-disable no-restricted-imports */
import { Deposit } from './actions/deposit';
import { SwapToRocketEth } from './actions/swapToRocketEth';
import { Withdraw } from './actions/withdraw';
import { GetCollateralRate } from './getters/getCollateralRate';
import { GetEthValue } from './getters/getEthValue';
import { GetExchangeRate } from './getters/getExchangeRate';
import { GetRethValue } from './getters/getRethValue';
var actions = {
    Deposit: Deposit,
    Withdraw: Withdraw,
    SwapToRocketEth: SwapToRocketEth,
};
var getters = {
    GetExchangeRate: GetExchangeRate,
    GetRethValue: GetRethValue,
    GetEthValue: GetEthValue,
    GetCollateralRate: GetCollateralRate,
};
var RocketPool = {
    actions: actions,
    getters: getters,
};
export { RocketPool };
